import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import "./index.scss";
import * as _ from "lodash";
import Tabs from "../../components/core/tab";
import { useDispatch, useSelector } from "react-redux";
import { tokenAction } from "../../store/token/slice";
import { useTranslation } from "react-i18next";

const ManageLayout = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const tokenManage = useSelector((state) => state.tokenManage);
  const hasToken = _.get(tokenManage, "hasToken");

  const configTabs = {
    isPath: true,
    tabs: [
      { label: t("settings.layout.request"), path: "/izi-message/request" },
      { label: t("settings.layout.report"), path: "/izi-message/report" },
      { label: t("settings.layout.profile"), path: "/izi-message/profile" },
    ],
  };

  useEffect(() => {
    const interval = setInterval(() => {
      dispatch(tokenAction.checkToken());
    }, 1000);

    if (hasToken) {
      clearInterval(interval);
    }

    return () => clearInterval(interval);
  }, [hasToken, dispatch]);

  return (
    <div className="container" style={{maxWidth: "100%"}}>
      <div>
        <h3 className="color-pri">iMessage</h3>
        <Tabs config={configTabs} />
        <br />
        <div>
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default ManageLayout;
